"use client"

import { usePathname } from "next/navigation"
import Header from "@/components/layout/Header"
import BottomNav from "@/components/layout/BottomNav"
import { Toaster } from "@/components/ui/toaster"

// /survey 경로에서는 Header/BottomNav를 숨김 (비인증 사용자용 페이지)
const HIDE_NAV_PATTERNS = ["/survey", "/itinerary/share", "/landing"]

export function LayoutShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  const hideNav = HIDE_NAV_PATTERNS.some((pattern) =>
    pathname.startsWith(pattern)
  )

  if (hideNav) {
    return (
      <>
        {children}
        <Toaster />
      </>
    )
  }

  return (
    <>
      <Header />
      {children}
      <BottomNav />
      <Toaster />
    </>
  )
}
